import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from '../pages/Home';
import { ListQuizzes } from '../pages/Quiz/ListQuizzes';
import { EditQuiz } from '../pages/Quiz/EditQuiz';
import { ListQuizSubmissions } from '../pages/Quiz/ListSubmissions';
import { ListCrosswords } from '../pages/Crossword/ListCrosswords';
import { EditCrossword } from '../pages/Crossword/EditCrossword';
import { ListCrosswordSubmissions } from '../pages/Crossword/ListSubmissions';
import { ListWordSearches } from '../pages/WordSearch/ListWordSearches';
import { EditWordSearch } from '../pages/WordSearch/EditWordSearch';
import { ListWordSearchSubmissions } from '../pages/WordSearch/ListSubmissions';
import { ComingSoon } from '../pages/ComingSoon';
import { PageNotFound } from '../pages/PageNotFound';
import { Header } from '../components/UI/Header';
import { NavPane } from '../components/UI/NavPane';
import { NotificationToast } from '../components/UI/NotificationToast';
import { useScrollbarVisibility } from '../hooks/ui';
const AppRouter = (params) => {
    // Initialize scrollbar visibility hook
    useScrollbarVisibility();
    return (React.createElement(BrowserRouter, null,
        React.createElement("div", { className: "root-container" },
            React.createElement(NotificationToast, null),
            React.createElement("div", { className: "header-container" },
                React.createElement(Header, { auth: params.auth })),
            React.createElement("div", { className: "main-container" },
                React.createElement("div", { className: "nav-container" },
                    React.createElement(NavPane, null)),
                React.createElement("div", { className: "app-container" },
                    React.createElement(Routes, null,
                        React.createElement(Route, { path: "/", Component: Home }),
                        React.createElement(Route, { path: "/quizzes", Component: ListQuizzes }),
                        React.createElement(Route, { path: "/quizzes/:id", Component: EditQuiz }),
                        React.createElement(Route, { path: "/quizzes/:id/submissions", Component: ListQuizSubmissions }),
                        React.createElement(Route, { path: "/crosswords", Component: ListCrosswords }),
                        React.createElement(Route, { path: "/crosswords/:id", Component: EditCrossword }),
                        React.createElement(Route, { path: "/crosswords/:id/submissions", Component: ListCrosswordSubmissions }),
                        React.createElement(Route, { path: "/word-searches", Component: ListWordSearches }),
                        React.createElement(Route, { path: "/word-searches/:id", Component: EditWordSearch }),
                        React.createElement(Route, { path: "/word-searches/:id/submissions", Component: ListWordSearchSubmissions }),
                        React.createElement(Route, { path: "/surveys", Component: ComingSoon }),
                        React.createElement(Route, { path: "/interactive-quizzes", Component: ComingSoon }),
                        React.createElement(Route, { path: "/library", Component: ComingSoon }),
                        React.createElement(Route, { path: "/organisations", Component: ComingSoon }),
                        React.createElement(Route, { path: "/profile", Component: ComingSoon }),
                        React.createElement(Route, { path: "/settings", Component: ComingSoon }),
                        React.createElement(Route, { path: "*", Component: PageNotFound })))))));
};
export { AppRouter };
